import { keyframes } from "styled-components"

export const rotate = keyframes`
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

export const floatUpAndGrow = keyframes`
  0% {
    opacity: 0;
  }

  10% {
    opacity: 1;
  }

  100% {
    transform: scale(1.5) translateY(-600%);
    opacity: 0;
  }
`

export const popFromCenter = keyframes`
0% {
    opacity: 0;
    transform: scale(0);
  }

  10% {
    transform: scale(0.8);
    opacity: 0.5;

  }

  50% {
    transform: scale(1);
  }

  75% {
    opacity: 0.7;
    transform: scale(1);
  }

  100% {
    transform: scale(0);
    opacity: 0;
  }
`
